// src/OngoingIssues.js
import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';
import './OngoingIssues.css';
import ResolveIssueModal from './ResolveIssueModal';

function OngoingIssues({ closeModal, showNotification }) {
  const [issues, setIssues] = useState([]);
  const [selectedIssue, setSelectedIssue] = useState(null);

  useEffect(() => {
    const fetchIssues = async () => {
      try {
        const issuesRef = collection(db, 'issues');
        const q = query(issuesRef, where('resolved', '==', false));
        const querySnapshot = await getDocs(q);
        const fetchedIssues = [];
        querySnapshot.forEach((doc) => {
          fetchedIssues.push({ id: doc.id, ...doc.data() });
        });
        setIssues(fetchedIssues);
      } catch (error) {
        console.error('Error fetching documents: ', error);
        alert('Failed to fetch ongoing issues.');
      }
    };

    fetchIssues();
  }, []);

  const handleResolveClick = (issue) => {
    setSelectedIssue(issue);
  };

  const closeResolveModal = () => {
    setSelectedIssue(null);
  };

  const resolveIssue = async (id, resolutionComment) => {
    try {
      const issueRef = doc(db, 'issues', id);
      await updateDoc(issueRef, {
        resolved: true,
        dateResolved: new Date().toISOString().split('T')[0],
        commentResolved: resolutionComment,
      });
      setIssues((prevIssues) => prevIssues.filter((issue) => issue.id !== id));
      closeResolveModal();
      showNotification('Issue resolved successfully.', 'success');
    } catch (error) {
      console.error('Error updating document: ', error);
      showNotification('Failed to resolve issue.', 'error');
    }
  };

  return (
    <div>
      <h3>Ongoing Issues</h3>
      {issues.length > 0 ? (
        issues.map((issue) => (
          <div key={issue.id} className="issue-card">
            <p>
              <strong>Theater {issue.theaterNumber}, Seat {issue.seatNumber}</strong>
            </p>
            <p>
              <strong>Comment:</strong> {issue.comment}
            </p>
            <p>
              <strong>Date Reported:</strong> {issue.dateReported}
            </p>
            <button onClick={() => handleResolveClick(issue)}>Resolve</button>
          </div>
        ))
      ) : (
        <p>No ongoing issues.</p>
      )}
      {selectedIssue && (
        <ResolveIssueModal
          issue={selectedIssue}
          onClose={closeResolveModal}
          onResolve={resolveIssue}
        />
      )}
    </div>
  );
}

export default OngoingIssues;
